import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PublicLinkService } from '@simOn/public-link';
import { API_URL } from '@simOn/utils/tokens';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { EMPTY, Observable, map, switchMap, take } from 'rxjs';

@Injectable()
export class TokenInjectorInterceptor implements HttpInterceptor {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private apiUrl = inject(API_URL);
  private publicLinkService = inject(PublicLinkService);
  private router = inject(Router);
  private readonly publicWhiteList: string[] = [this.apiUrl + '/news/GetNews'];
  private readonly apiBlackList = this.publicLinkService.getPublicLinkApiBlackList(this.apiUrl);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.publicLinkService.publicLink && this.publicLinkService.getGuid()
      ? this.checkPublicLink(request, next)
      : this.checkUser(request, next);
  }
  private checkUser(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.publicWhiteList.includes(request.url)) {
      return next.handle(request);
    }
    if (this.publicLinkService.publicLink && this.publicLinkService.getGuid()) {
      return this.checkPublicLink(request, next);
    }

    if (request.responseType !== 'blob' || request.url.startsWith(this.apiUrl)) {
      return this.oidcSecurityService.getAccessToken().pipe(
        take(1),
        map((accessToken: string) => {
          return request.clone({
            headers: request.headers.set('Authorization', `Bearer ${accessToken}`)
          });
        }),
        switchMap((response) => next.handle(response))
      );
    }

    return next.handle(request);
  }
  private checkPublicLink(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.apiBlackList.includes(request.url)) {
      return EMPTY;
    }

    if (request.url.includes('navvis.com')) {
      return next.handle(request);
    }

    // Exactly one credential: `publicLinkToken` (JWT link) or `PublicLink` (legacy GUID); the backend rejects both.
    const credential = this.publicLinkService.credentialHeader() ?? {
      name: 'PublicLink',
      value: this.publicLinkService.publicLink || ''
    };
    request = request.clone({
      withCredentials: true,
      setHeaders: {
        [credential.name]: credential.value,
        'Current-Routing': this.router.routerState.snapshot.url
      }
    });
    return next.handle(request);
  }
}
